import React from "react"
import PropTypes from "prop-types"

const SVG = ({ className, size }) => (
  <svg viewBox="0 0 509.867 509.867" className={className} {...size}>
    <path
      d="M336 263.467c7.467-7.467 11.733-17.067 11.733-27.733v-54.4c0-26.667-11.733-51.2-29.867-68.267-6.4-5.333-11.733-12.8-16-19.2H208c-4.267 7.467-9.6 13.867-16 19.2-18.133 17.067-29.867 40.533-29.867 68.267v60.8c0 8.533 5.333 14.933 11.733 20.267 4.267 4.267 4.267 19.2 0 23.467-6.4 5.333-11.733 11.733-11.733 20.267V480c0 6.4 3.2 11.733 7.467 16 6.4 8.533 16 13.867 27.733 13.867 8.533 0 17.067-3.2 22.4-8.533h11.733c6.4 5.333 13.867 8.533 22.4 8.533 8.533 0 17.067-3.2 22.4-8.533H288c6.4 5.333 13.867 8.533 22.4 8.533 11.733 0 21.333-5.333 27.733-13.867 4.267-4.267 7.467-9.6 7.467-16V308.267c0-5.333-3.2-11.733-6.4-16L336 288c-6.4-6.4-6.4-18.133 0-24.533z"
      fill="#84dbff"
    />
    <path
      d="M217.6 54.4l1.067 6.4c0 17.067-6.4 33.067-18.133 46.933h110.933c-10.667-12.8-18.133-28.8-18.133-46.933v-6.4h1.067c2.133 0 4.267-2.133 4.267-4.267 0-2.133-2.133-4.267-4.267-4.267h-1.067V34.133H217.6v9.6h-1.067c-2.133 0-4.267 2.133-4.267 4.267.001 4.267 2.134 6.4 5.334 6.4z"
      fill="#f2f2f2"
    />
    <path
      d="M285.867 0h-59.733c-5.333 0-10.667 4.267-10.667 10.667V35.2h81.067V10.667C296.533 4.267 291.2 0 285.867 0z"
      fill="#40596b"
    />
    <path fill="#54c0eb" d="M163.2 325.333h184.533v110.933H163.2z" />
    <path fill="#54c0eb" d="M163.2 325.333h184.533v110.933H163.2z" />
    <path
      d="M283.733 394.667c0 14.933-12.8 27.733-27.733 27.733s-27.733-12.8-27.733-27.733 27.733-54.4 27.733-54.4 27.733 38.4 27.733 54.4z"
      fill="#fff"
    />
    <path
      d="M262.4 414.933c-14.933 0-27.733-12.8-27.733-27.733 0-10.667 13.867-34.133 22.4-46.933-1.067 0-1.067-1.067-1.067-1.067s-27.733 39.467-27.733 54.4 12.8 27.733 27.733 27.733c9.6 0 17.067-4.267 22.4-11.733-4.267 4.267-9.6 5.333-16 5.333z"
      opacity=".1"
      fill="#231f20"
    />
  </svg>
)

SVG.propTypes = {
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

export default SVG
